//@ts-ignore
import $i18n from '@/i18n';
import React from 'react';
import DarkToolTip from '../../../../../../components/DarkToolTip';

import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'




const renderName = (v, i, record) => (v)
const baseRenderCell = (v, i, record) => (JSON.stringify(v))

const iconCellRender = (v, i, record) => v === 'CONTROLLED' ? <CheckCircleOutlined style={{ fontSize: 14, color: '#29A64E' }} /> : <CloseCircleOutlined style={{ fontSize: 14, color: "#D4D6DB" }} />


const tipRenderCell = (v, i, record) => <DarkToolTip trigger={['click']} placement="topLeft" arrow={{ pointAtCenter: true }} triggerContent={v} content={v} />

const handleFilters = (values) => {
  const filter: Array<{ label: string, value: string }> = [];
  for (const [key, value] of Object?.entries(values)) {
    filter?.push({ label: value as unknown as string, value: key });
  }
  return filter;
};

const channelFilters = (openJsApiAuthChannels) => handleFilters(openJsApiAuthChannels)

export const tableColumons = (openJsApiAuthChannels) => [
  {
    title: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.jsapiName", dm: '名称' }),
    dataIndex: 'jsapiName',
    width: 140,
    cell: tipRenderCell,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.functionDesc', dm: '描述' }),
    dataIndex: 'functionDesc',
    cell: tipRenderCell,
    width: 166,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.channelName', dm: '渠道' }),
    dataIndex: 'channelName',
    cell: tipRenderCell,
    width: 97,
    filters: channelFilters(openJsApiAuthChannels),
    filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.supportSystem', dm: '支持的系统' }),
    dataIndex: 'supportSystem',
    width: 149,
    cell: (v) => v?.join(' / '),
  }
];
